
import axios from "axios"
import { Message } from 'element-ui';
const $erMsg = (message) => {
    Message({
        message,
        type: "error",
        duration: 800
    })
}

// vin查询 
const fetch = async (url, data, method) => {
    if (!data.appId) {
        data.appId = "wx__F8Zwnruhs8blnOxFTjhw"
    }
    // data.appId = "ce__F8Zwnruhs8blnOxFTjhw"
    
    let baseUrl = "https://api.geweapi.com"



    let httpRequest = new XMLHttpRequest();//第一步：建立所需的对象
    if (method == 'post') {
       
        httpRequest.open('POST', baseUrl + url)
        //设置Content-Type属性
        httpRequest.setRequestHeader('Content-Type', 'application/json') 
        if(data.token){
            httpRequest.setRequestHeader('X-GEWE-TOKEN',data.token ) 
        }else{
            httpRequest.setRequestHeader('X-GEWE-TOKEN', '4868c916-f1e6-4ed2-9085-4e7e5f78f9ee') 
        }
        //调用send函数
        httpRequest.send(JSON.stringify(data))
        
    } else {
        // 
        httpRequest.open('GET', baseUrl + url, true);//第二步：打开连接  将请求参数写在url中  ps:"./Ptest.php?name=test&nameone=testone"
        httpRequest.send();//第三步：发送请求  将请求参数写在URL中
    }
    /**
     * 获取数据后的处理程序
     */
    let res = await new Promise((rep, rej) => {
        httpRequest.onreadystatechange = function () {
            if (httpRequest.readyState == 4 && httpRequest.status == 200) {
                let json = httpRequest.responseText;//获取到json字符串，还需解析
                try {
                    json = JSON.parse(json)
                    rep(json)
                } catch (e) {
                    console.error(e)
                    //    $erMsg("解析失败")
                    rej(e)
                }
            }
        };
    })
    return res
}
// vin查询
// "ats": "notify@all",
const getUserList = async (data) => {
    return await fetch("/gewe/v2/api/contacts/fetchContactsList", data, 'post')
}
// 获取群/好友详细信息
const getDetailInfo = async (data) => {
    return await fetch("/gewe/v2/api/contacts/getDetailInfo", data, 'post')
}
const sendMsg = async (data) => {
    console.log("data",data);
    return await fetch("/gewe/v2/api/message/postText", data, 'post')
}
const sendFileMsg = async (data) => {
    return await fetch("/gewe/v2/api/message/postFile", data, 'post')
}

const sendImgMsg = async (data) => {
    return await fetch("/gewe/v2/api/message/postImage",data, 'post')
}
const getWxInfo = async (data) => {
   
    return await fetch("/gewe/v2/api/personal/getProfile",data, 'post')
}
// 撤回消息
const revokeMsg = async (data) => {
    
    console.log("撤回消息",data);
    
    return await fetch("/gewe/v2/api/message/revokeMsg",data, 'post')
}

const apiGewe = {
    sendMsg,
    sendFileMsg,
    sendImgMsg,
    getUserList,
    getDetailInfo,
    getWxInfo,
    revokeMsg
}

export default apiGewe